import React from "react";

// Hasta cuántos nombres se listan; el resto va como "y N más".
const MAX_NOMBRES = 10;

/**
 * KAN-52 — Aviso de los archivos que quedan fuera de una descarga por tener
 * los derechos de uso vencidos, con su ruta. Lo usan la descarga de carpeta
 * (MultiDownloadModalFolder) y la de selección múltiple (MultiDownloadModal).
 * La lista la arma el backend (dowloadMultipleTest con `withExcluded`), que
 * también es el que los saca de la descarga.
 *
 * `messageId` es el encabezado (recibe {count}); por defecto, el genérico.
 */
const RightsExcludedNotice = ({ intl, excluded, messageId }) => {
  if (!excluded || excluded.length === 0) return null;
  const visibles = excluded.slice(0, MAX_NOMBRES);
  const resto = excluded.length - visibles.length;
  return (
    <div
      style={{
        margin: "-24px auto 24px",
        width: "70%",
        fontSize: 13,
        color: "#d48806"
      }}
    >
      {intl.formatMessage(
        { id: messageId || "download_rights_excluded" },
        { count: excluded.length }
      )}
      <ul style={{ margin: "6px 0 0", paddingLeft: 18, maxHeight: 160, overflowY: "auto" }}>
        {visibles.map(item => (
          <li key={item._id || item.path} style={{ wordBreak: "break-all" }}>
            {item.path || item.name}
          </li>
        ))}
        {resto > 0 && (
          <li>
            {intl.formatMessage(
              { id: "download_rights_excluded_more" },
              { count: resto }
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default RightsExcludedNotice;
